

import React from "react";
import cardImg1 from "../assets/images/services/img1.jpeg";
import cardImg2 from "../assets/images/nima.jpg";
import cardImg3 from "../assets/images/services/img4.jpg";
import cardImg4 from "../assets/images/services/img3.jpeg";

const resources = {

  about: {
    hero: {
      video: require("../assets/videos/video8.mp4"),
      image: require("../assets/images/information/shehroze.png"),

      left: {
        subtitle: "High altitude mountain climber",
        title: "SHEHROZE",
      },

      right: {
        title: "KASHIF",
        description:
          "Born in Lahore, Pakistan, I summited Broad Peak earning the nickname “The Broad Boy”.",
      },
    },
    achievements: {
      background: require("../assets/images/img11.png"),

      header: {
        backgroundText: "BROADBOY",
        foregroundText: "ACHIEVEMENTS",
      },

      intro:
        "By 19, I had scaled Everest, and on 9 October 2024, I completed climbing all 14 of the world’s 8,000-meter peaks. This journey is more than summits; it's about passion, perseverance, and proving that no dream is too big.",

      items: [
        {
          id: 1,
          number: "01",
          title: "Youngest Pakistani",
          description: "The youngest mountaineer to summit all 14×8000ers.",
        },
        {
          id: 2,
          number: "02",
          title: "Hilal-e-Imtiaz",
          description: "One of Pakistan’s highest civilian honors.",
        },
        {
          id: 3,
          number: "03",
          title: "Guinness World Record",
          description:
            "Youngest person to summit K2 & Everest and youngest to complete 14×8000ers.",
        },
        {
          id: 4,
          number: "04",
          title: "Acclaimed Mountaineer",
          description:
            "Recognized worldwide for historic summits and groundbreaking mountaineering.",
        },
      ],
    },
    approach: {
      background: require("../assets/images/hero-image-24.jpg"),
      profileImage: require("../assets/images/information/shehroze8.jpeg"),

      heading: "CONQUER THE IMPOSSIBLE",

      paragraphs: [
        "After conquering 14×8000m peaks, one thing became obvious, adventure isn’t sold in brochures. It’s earned.",
        "We guide climbers through the world’s most demanding environments, obsessing over details because every detail matters at altitude.",
        "The BroadBoy way... simple, but never easy.",
      ],

      highlightIndex: 2,

      rating: {
        text: "⭐⭐⭐⭐⭐ 4.9 / 5",
        sub: "32+ happy climbers",
      },

      cta: {
        text: "Book a 15-Min Call",
        link: "https://calendly.com/broadboyadventures/15min",
      },

      contact: {
        email: "info@broadboyadventures.com",
        description:
          "With years spent on the world’s highest peaks, BroadBoy Adventures helps climbers turn ambition into real-world ascent, guided by true experience, not theory.",
      },

      socials: [
        {
          id: "x",
          link: "https://x.com/Shehrozekashif2",
        },
        {
          id: "instagram",
          link: "https://www.instagram.com/bb.adventures_",
        },
      ],

      footer: {
        title: "Led by Shehroze Kashif",
        description:
          "We take trekkers and climbers into the heart of the world’s greatest ranges. Exploring deeper and Climbing higher",
      },
    },
    clients: {
      background: require("../assets/images/hero-image-22.jpg"),

      header: {
        left: {
          index: "[01]",
          label: "Expeditions",
        },
        title: "CLIENTS",
        right: "Since 2020 – 2025",
      },

      columns: [
        [
          {
            id: 1,
            number: "[01]",
            title: "K2 Summit Expedition",
            year: "2025",
            subtitle: "High-Altitude Technical Climb",
            image: require("../assets/images/img6.png"),
            aspect: "aspect-square",
          },
          {
            id: 4,
            number: "[04]",
            title: "Gasherbrum I",
            year: "2024",
            subtitle: "Alpine Style Expedition",
            image: require("../assets/images/img7.png"),
            aspect: "aspect-[0.76/1]",
          },
        ],
        [
          {
            id: 2,
            number: "[02]",
            title: "Broad Peak",
            year: "2024",
            subtitle: "Technical Ice & Rock",
            image: require("../assets/images/img4.png"),
            aspect: "aspect-[0.75/1]",
          },
          {
            id: 5,
            number: "[05]",
            title: "Nanga Parbat",
            year: "2024",
            subtitle: "Rupal Face Challenge",
            image: require("../assets/images/img5.png"),
            aspect: "aspect-[0.75/1]",
          },
        ],
        [
          {
            id: 3,
            number: "[03]",
            title: "Everest South Col",
            year: "2024",
            subtitle: "World’s Highest Peak",
            image: require("../assets/images/img9.png"),
            aspect: "aspect-[0.97/1]",
          },
          {
            id: 6,
            number: "[06]",
            title: "Karakoram Traverse",
            year: "2024",
            subtitle: "Glacier Crossing",
            image: require("../assets/images/img1.png"),
            aspect: "aspect-[4/3]",
          },
        ],
      ],
    },
    whyChooseUs: {
        background: require("../assets/images/hero-image-12.jpg"),
        cardImage: require("../assets/images/image4.jpg"),

        label: {
          index: "[02]",
          text: "Why choose us",
        },

        heading:
          "We deliver more than adventure. We deliver momentum.",

        description:
          "BroadBoy Adventures is built on the spirit of exploration. We document Himalayan expeditions, mountaineering feats, and cinematic mountain journeys bringing the raw beauty and grit of mountains to you.",

        stats: {
          value: "50+",
          label: "Successful expeditions completed worldwide.",
          years: ["2021", "2022", "2023", "2024", "2025"],

          speedValue: "3x",
          speedLabel:
            "Faster than traditional expedition planning and coordination.",

          rating: "4.9",
          ratingTotal: "/ 5",

          brand: "BroadBoyAdventures",

          clients: "32+",
          clientsLabel:
            "Happy climbers and counting from first-timers to elite mountaineers.",

          reachValue: "23+",
          reachLabel:
            "Expedition & trekking projects across Nepal, China & Pakistan.",
        },
    },
    faq: {
      background: require("../assets/images/hero-image-12-a.jpg"),

      label: {
        index: "[03]",
        text: "FAQs",
      },

      heading: "Questions.",

      description:
        "Everything you need to know before joining a BroadBoy Adventures expedition or trekking journey.",

      items: [
        {
          id: 1,
          q: "What type of expeditions does BroadBoy Adventures organize?",
          a: "We specialize in high-altitude mountaineering expeditions, classic Himalayan peaks, and remote alpine climbs.\n\nOur journeys are designed for both seasoned climbers and ambitious first-timers seeking real mountain experiences.",
        },
        {
          id: 2,
          q: "Do you offer trekking programs for beginners?",
          a: "Yes. We organize guided trekking adventures including base camp treks, scenic alpine routes, and cultural mountain trails suitable for beginners and intermediate trekkers.",
        },
        {
          id: 3,
          q: "How experienced are your expedition leaders?",
          a: "Our expeditions are led by certified guides with years of Himalayan experience, local mountain knowledge, and proven high-altitude leadership across Pakistan, Nepal, and beyond.",
        },
        {
          id: 4,
          q: "What safety measures are in place during expeditions?",
          a: "Safety is our top priority. We follow strict acclimatization schedules, carry medical and rescue equipment, monitor weather conditions closely, and maintain constant communication throughout the journey.",
        },
        {
          id: 5,
          q: "How physically demanding are your trekking and climbing trips?",
          a: "Each expedition clearly states its difficulty level. We offer everything from moderate treks to demanding technical climbs, allowing participants to choose adventures that match their fitness and experience.",
        },
        {
          id: 6,
          q: "Can I customize a private expedition or trekking trip?",
          a: "Absolutely. We design custom expeditions and private trekking itineraries for individuals, groups, filmmakers, and adventure teams based on specific goals and timelines.",
        },
      ],
    },
    companyInfo: {
      logo: require("../assets/images/logo/light-logo-half.png"),

      watermarkTop: "BROADBOY",
      watermarkBottom: "ADVENTURES",

      description: "Join us where courage meets altitude. Where dreams climb higher than the clouds. Let’s conquer peaks and rewrite what’s possible together. At BroadBoy Adventures, every expedition is a story of belief, resilience, and discovery. We elevate climbers to push beyond limits and experience what only a few dare to chase. Adventure isn’t just where we go  it’s who we become. Stand above the clouds. Live the stories people will tell for years.BroadBoy Adventures Where legends rise, one summit at a time.",

      socials: [
        {
          id: 1,
          logo: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png",
          name: "Instagram",
          description:
            "Follow behind-the-scenes, expeditions, updates and exclusive moments.",
          button: "Follow us",
          link: "https://www.instagram.com/bb.adventures_",
        },
        {
          id: 2,
          logo: "https://framerusercontent.com/images/lTRuCxkmxeIKqNbj2JiXUFWgdw.png",
          name: "YouTube",
          description:
            "Tips, documentaries, and in-depth expedition videos to inspire the community",
          button: "Subscribe",
          link: "https://www.youtube.com/@TheBroadBoy",
        },
      ],
    },
    partnership: {
      background: require("../assets/images/hero-image-12.jpg"),

      header: {
        label: "TRUSTED PARTNERSHIP",
        title: "IN COLLABORATION",
        highlight: "WITH",
        text: "Our partners are our support"
      },

      brandLogo: require("../assets/images/logo/light-logo-full.png"),

      partners: [
        {
          id: "seven-summit",
          logo: require("../assets/images/trusted-partners/seven-summit-treks-logo.png"),
          name: "Seven Summit",
        },
        {
          id: "karakoram",
          logo: require("../assets/images/trusted-partners/karakoram-club-logo.PNG"),
          name: "Karakoram Club",
        },
         {
          id: "pelliot",
          logo: require("../assets/images/trusted-partners/pelliot-logo.jpg"),
          name: "Pelliot",
        },
      ],
    },
  },

  blog: {
  heading: {
    badge: "Blog",
    title: "Stories from the Mountains",
    subtitle:
      "Insights, expedition guides, and untold tales from the highest mountains on Earth.",
  },
  posts: [
    {
      id: 1,
      title: "From Dream to Summit: Conquering the Highest Peaks",
      category: "Expedition Guide",
      imageUrl: cardImg1,
      content:
        "Follow the journey behind world-record expeditions and learn what it truly takes to reach the top of the world. Training routines, logistics, permits, and survival  all broken down by the BroadBoy Adventures team.",
      component: React.lazy(() => import("../components/blogs/BlogPost1")),
    },
    {
      id: 2,
      title: "Why Nima Rinji Sherpa’s Record Matters for Every Young Mountaineer",
      category: "Achievements",
      imageUrl: cardImg2,
      content:
        "The Nepalese mountaineer  has etched his name in climbing history by becoming the **youngest person ever** to summit all 14 of the world’s 8,000-meter peaks. On October 9, 2024, at just 18 years old, he completed his final ascent by reaching the summit of  (8,027 m). Nima began high-altitude climbing in 2022, and over a span of roughly two years and 14 summits, he overcame extreme altitude, challenging weather, and logistical hurdles  proving that with skill, determination, and respect for the mountains, unprecedented feats are possible, even at a young age.His achievement is more than just a personal record: for aspiring climbers around the world, especially from Himalayan communities, Nima’s journey signals that age or background need not be a barrier. BroadBoy Adventures draws inspiration from that spirit  aiming to celebrate, support, and elevate young climbers who dream big.\n",
      component: React.lazy(() => import("../components/blogs/BlogPost2")),
    },
    {
      id: 3,
      title: "A Beginner’s Guide to Himalayan Expeditions",
      category: "Resources",
      imageUrl: cardImg3,
      content:
        "New to high-altitude adventures? This guide covers preparation, gear, acclimatization, costs, and choosing the right mountain for your skill level.",
      component: React.lazy(() => import("../components/blogs/BlogPost3")),
    },
    {
      id: 4,
      title: "Inside BroadBoy Basecamps: Where Adventure Comes Alive",
      category: "Article",
      imageUrl: cardImg4,
      content:
        "Step inside the heartbeat of our expeditions  from snowy sunrise briefings to high-altitude resilience. A closer look at the culture, teamwork, and stories from camp life.",
      component: React.lazy(() => import("../components/blogs/BlogPost4")),
    },
  ],
}

};

export default resources;
